import { ContainerApplicationController } from 'web-interactives-embed-framework';
import { createFormController } from 'ui-forms-embed-components-frame-container/controllers/FormController/FormControllerV4';
import { createRecaptchaContainerController } from './RecaptchaContainerController';
export class ApplicationController extends ContainerApplicationController {
  initHubspotForm() {
    this.formController = createFormController({
      applicationController: this
    });
    this.recaptchaController = createRecaptchaContainerController(this);
  }
}
export function createApplicationController() {
  return new ApplicationController();
}